import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'lib-placeholder',
    templateUrl: './placeholder.component.html',
    styleUrls: ['./placeholder.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class PlaceholderComponent implements OnInit {
  @Input() message: string = '';
  @Input() condition: boolean = false;
  @Input() iconClass: string = 'icon-info';
  @Input() iconName: string = 'warning';

  ngOnInit(): void {
    this.iconClass += ' icon-display'
  }
}
